import i18n from '@/i18n';

export default [
    {
        get text() { return i18n?.global?.t('tableHeaders.id')},
        value: 'id',
        sortable: true,
    },
    { get text() { return i18n?.global?.t('tableHeaders.name')}, value: 'name' },
    { get text() { return i18n?.global?.t('tableHeaders.type')}, value: 'type' },
    { get text() { return i18n?.global?.t('tableHeaders.group')}, value: 'item_group' },
    {
        get text() { return i18n?.global?.t('common.equipmentState')},
        value: 'equipment_state_id',
    },
    {
        get text() { return i18n?.global?.t('tableHeaders.criticality')},
        value: 'criticality',
    },
    {
        get text() { return i18n?.global?.t('tableHeaders.designation')},
        value: 'designation',
    },
    {
        get text() { return i18n?.global?.t('tableHeaders.symbol')},
        value: 'symbol',
        sortable: true,
    },
    {
        get text() { return i18n?.global?.t('tableHeaders.department')},
        value: 'department',
        sortable: true,
    },
    {
        get text() { return i18n?.global?.t('common.location')},
        value: 'location_name',
        sortable: true,
    },
    {
        get text() { return i18n?.global?.t('common.productionLine')},
        value: 'prod_line',
    },
    // {
    //     get text() { return '',
    //     value: 'issues_counter',
    //     width: 450,
    // },
    {
        value: 'operation',
        width: 54,
        fixed: true,
    },
];
